/**
 * The quiet, persistent banner for GitLab not responding.
 *
 * BEST serves what it shows from its own database, so viewing carries on; what
 * stops is anything that publishes, because every save is a commit to GitLab.
 * Said once, at the top, rather than as a failure on each button - and gone as
 * soon as GitLab answers (the shell re-asks on an interval while it is down).
 *
 * Nothing is queued to publish later: the file in the repository is the record,
 * so an edit that has not been saved is kept on the page and nowhere else.
 */

import Alert from '@mui/material/Alert'
import { usePrincipal } from '../../state/AppData'

export default function GitLabNotice() {
  const principal = usePrincipal()
  if (principal.gitlab_reachable !== false) return null

  return (
    <Alert severity="warning" role="status" sx={{ mb: 2 }}>
      GitLab is not responding. You can keep viewing; saving is paused until it is
      back. Edits you have made on this page stay here, so keep it open.
    </Alert>
  )
}
